/** Alternative colors are lighter. */
export const pcpRedPalette = {
    notificationForeground: " #DB4429",
    foregroundLight: ' #F0471D',
    foregroundLightAlternative: ' #FF9379',
    foregroundDark: ' #F03000',
    foregroundDarkAlternative: ' #FF7857',
    foregroundDarker: ' #E4350A',
}